module.exports = __webpack_public_path__ + "img/robot.865aa269.png";